module.exports = __webpack_public_path__ + "static/28d-card-with-awards-1d0c59aafaded2b3d762060a748f4fe6.png";